import * as marietta from '../..';
import {
  webcadDefines, SharedManagers, ThreeView,
} from '.';

/* View3dGlobal
 * グローバル定義.
 */
export class View3dGlobal {
    static threeView: ThreeView;

    static shared: SharedManagers;

    public static init_shared(params?: any) {
      if (this.shared == undefined) {
        if (params == undefined) { params = {}; }

        if (params[webcadDefines.GlobalDefs.remoteBaseUrlName] == undefined) {
          const url = params.webcad_url;
          params[webcadDefines.GlobalDefs.remoteBaseUrlName] = url;
        }
        // 開発時のベースURL.
        if (params[webcadDefines.GlobalDefs.localBaseUrlName] == undefined) { params[webcadDefines.GlobalDefs.localBaseUrlName] = './'; }
        // 3d ディレクトリ.
        if (params[webcadDefines.GlobalDefs.threedDirName] == undefined) { params[webcadDefines.GlobalDefs.threedDirName] = marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_3d_url; }
        // 3dアイテムディレクトリ.
        if (params[webcadDefines.GlobalDefs.itemDirName] == undefined) { params[webcadDefines.GlobalDefs.itemDirName] = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_3d_url}item/`; }
        // テクスチャディレクトリ.
        if (params[webcadDefines.GlobalDefs.text3DBaseDirName] == undefined) { params[webcadDefines.GlobalDefs.text3DBaseDirName] = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/`; }
        // アニメーションデータディレクトリ.
        if (params[webcadDefines.GlobalDefs.animDataDirName] == undefined) { params[webcadDefines.GlobalDefs.animDataDirName] = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}animations/`; }
        // アイコンリソースディレクトリ.
        if (params[webcadDefines.GlobalDefs.libsDirName] == undefined) { params[webcadDefines.GlobalDefs.libsDirName] = marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url; }
        // アイテム定義ファイル.
        if (params[webcadDefines.GlobalDefs.clrDefPathName] == undefined) { params[webcadDefines.GlobalDefs.clrDefPathName] = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_3d_url}PartsDef.xml`; }

        // マテリアル定義ファイル.
        if (params[webcadDefines.GlobalDefs.matDefPathName] == undefined) { params[webcadDefines.GlobalDefs.matDefPathName] = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/material.xml`; }
        // デフォルトのマテリアル定義ファイル.
        if (params[webcadDefines.GlobalDefs.stylDefPathName] == undefined) { params[webcadDefines.GlobalDefs.stylDefPathName] = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/default_material.xml`; }

        // SharedManager に渡して設定を確定する.
        this.shared = new SharedManagers(params);
      }
    }
}
